<template>
  <div
    class="memberContainer"
    v-loading="loading"
    element-loading-text="上传中"
  >
    <nav-bar style="width: 100%" :type="type" />

    <div class="innerContainerGraph">
      <!-- 传递图集的部分 -->
      <div class="editContainer">
        <div class="sourceListContainer publicScroll">
          <div class="inputLabel">添加图片</div>
          <ul class="graphList">
            <li v-for="(item, index) in resource_url" :key="index">
              <div
                class="thumbContainer"
                @mouseenter="hoverIndex = index"
                @mouseleave="hoverIndex = -1"
              >
                <img :src="item" class="thumb" />
                <img
                  src="../../assets/imageDelete.png"
                  class="deleteFn"
                  @click="graphDelete(index)"
                />
                <!-- v-show="hoverIndex == index" -->
              </div>
            </li>
            <li v-show="resource_url.length < 20">
              <div class="thumbContainer">
                <el-upload
                  drag
                  action="no"
                  accept="image/*"
                  :before-upload="onBeforeUpload"
                  :http-request="uploadFn"
                  class="uploadElemBox"
                >
                  <div
                    style="
                      width: 100%;
                      height: 100%;
                      background-size: 100% 100%;
                      padding-top: 68px;
                      color: #999;
                    "
                    :style="{ backgroundImage: `url(${banner$})` }"
                  >
                    <!-- 已经添加图片的计数 -->
                    <span> {{ resource_url.length }}/20 </span>
                  </div>
                </el-upload>
              </div>
            </li>
          </ul>
        </div>
        <!-- 输入标题的部分 -->
        <div class="titleContain">
          <div class="titleLabelContain">
            <p class="titleLabel">添加标题</p>
            <!-- <p class="titleAiOutBtn" @click.stop="aiTitleShowFn()">标题推荐</p>
            <el-popover
              placement="bottom"
              width="461"
              trigger="manual"
              popper-class="titleAiContain"
              v-model="aiTitleShow"
              style="margin-left: 30px; margin-top: -20px"
            >
              <ul class="aiTitleList" v-loading="aiTitleLoading">
                <li
                  class="aiTitleItem"
                  v-for="(item, index) in aiTitle"
                  :key="index"
                  @click="aiTitleSelect(item)"
                >
                  <p class="aiTitleLabel">标题{{ index + 1 }}：</p>
                  <p class="aiTitleContent">{{ item }}</p>
                </li>
              </ul>
            </el-popover> -->
          </div>
          <el-input
            style="background: #f6f7f9; margin-bottom: 0; margin-right: 0"
            v-model="title"
            placeholder="请输入标题(2-30字)"
            clearable
            maxlength="30"
            show-word-limit
          ></el-input>
        </div>

        <!-- 输入正文的部分 -->
        <div class="contentContain">
          <p class="titleLabel">添加简介</p>
          <img
            src="../../assets/topic.png"
            class="topicBtn"
            title="插入话题"
            @click="insertTopic"
          />
        </div>

        <div class="topicListContainer" v-show="topicShowList.length">
          <div
            v-for="(item, index) in topicShowList"
            :key="index"
            class="topicList"
            @click="deleteTopic(index)"
          >
            #{{ item.title.replace(/#/gi, "") }}#
          </div>
        </div>

        <div style="display: flex">
          <el-input
            style="background: #f6f7f9"
            type="textarea"
            :rows="6"
            placeholder="请输入图片简介"
            v-model="content"
            resize="none"
            maxlength="400"
            show-word-limit
          >
          </el-input>
        </div>
      </div>

      <div class="right">
        <info-set
          :title="title"
          :content="content"
          :resource_url="resource_url"
          :material_ids="material_ids"
          :topicIds="topicIds"
          type="3"
          @preview="preview"
        />
      </div>
    </div>

    <el-dialog
      title="预览"
      :visible.sync="previewVisible"
      width="320px"
      top="5vh"
      class="previewContainer"
      :class="{ blackPage: blackPage }"
    >
      <el-carousel height="250px" :autoplay="false" indicator-position="none">
        <el-carousel-item v-for="(item, index) in resource_url" :key="index">
          <div class="itemContainer">
            <el-image
              fit="fill"
              :src="item.split('?')[0]"
              :preview-src-list="resource_url"
            />
            <p>{{ index + 1 }}/{{ resource_url.length }}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="info">
        <img :src="u_avatar" />
        <div>
          <p class="userName">{{ u_nickname }}</p>
          <p class="time">{{ getNowTime() }}</p>
        </div>
      </div>
      <p class="title">{{ title }}</p>
      <div>{{ content }}</div>
      <div class="topicsContainer" v-show="topicShowList.length > 0">
        <p
          v-for="(item, index) in topicShowList"
          :key="index"
          class="topicShow"
          @click="toTopicPage(item.id)"
        >
          {{ item.title }}
        </p>
      </div>
      <img
        src="../../assets/script/close.png"
        class="closeBtn"
        @click="previewVisible = false"
      />
    </el-dialog>

    <el-dialog
      title="插入话题"
      :visible.sync="insertTopicVisible"
      width="600px"
      class="insertTopicContainer"
    >
      <el-select
        v-model="topicValue"
        filterable
        remote
        default-first-option
        placeholder="请输入或者选择话题"
        :remote-method="getTopicList"
        @change="topicInputChange"
      >
        <el-option
          v-for="item in topicOptions"
          :key="item.id"
          :label="item.title"
          :value="item.id"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 550px;
          "
        >
          <span v-if="item.is_official == 1" style="color: #ea0e0e">(官方)</span
          >{{ item.title }}
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <div class="submitBtn" @click="insertTopicVisible = false">取 消</div>
        <div class="submitBtn" type="primary" @click="insertTopicFn">确 定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import NavBar from "../../components/NavBarForEdit";
import InfoSet from "./components/InfoSet";
import {
  RESOURCE_HOST,
  NEWS_HOST,
  MEDIA_HOST,
  SWNEWS_HOST,
} from "../../constants/apiHosts";
import { BehaviorSubject } from "rxjs";
import { HS_upload } from "./../../utils/huoshanUpload";
export default {
  data() {
    return {
      belong_id: "",
      loading: false,
      title: "",
      content: "",
      hoverIndex: -1,
      sourceList: [],
      page: 1,
      material_ids: "",
      resource_url: [],
      previewVisible: false,
      u_avatar: "",
      u_nickname: "",
      type: 3,
      topicIds: [],
      topicShowList: [],
      insertTopicVisible: false,
      topicOptions: [],
      topicValue: "",
      aiTitle: ["", "", ""],
      aiTitleShow: false,
      aiTitleLoading: false,
      blackPage: false,
    };
  },
  subscriptions() {
    return {
      banner$: new BehaviorSubject(require("../../assets/script/uploadF.png")),
    };
  },
  components: {
    NavBar,
    InfoSet,
  },
  filters: {},
  created() {
    this.u_avatar = localStorage.getItem("u_avatar")
      ? localStorage.getItem("u_avatar")
      : require("../../assets/moren.png");
    this.u_nickname = localStorage.getItem("u_nickname");

    let body = document.getElementsByTagName("body")[0];
    body.onclick = () => {
      this.aiTitleShow = false;
    };

    if (this.$route.query.draftId) {
      this.belong_id = this.$route.query.draftId;
      this.getDraftDetail();
    } else if (this.$route.query.scriptId) {
      this.belong_id = this.$route.query.scriptId;
      this.getScriptDetail();
    } else if (this.$route.query.materialId) {
      this.belong_id = this.$route.query.materialId;
      this.getMaterialDetail();
    } else if (this.$route.query.dhyId) {
      this.belong_id = this.$route.query.dhyId;
      this.getDhyDetail();
    } else if (this.$route.query.mediaId) {
      this.belong_id = this.$route.query.mediaId;
      this.getMediaDetail();
    }

    if (this.$route.query.topicId) {
      this.topicShowList.push({
        title: this.$route.query.topicTitle,
        id: this.$route.query.topicId,
      });
      this.topicIds.push(this.$route.query.topicId);
    }

    //this.getMaterialList();
  },
  mounted() {},
  methods: {
    preview(setTheme) {
      if (setTheme == 0) {
        this.blackPage = true;
      } else {
        this.blackPage = false;
      }
      this.previewVisible = true;
    },
    getNowTime() {
      var date = new Date();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return (
        month +
        "月" +
        date.getDate() +
        "日 " +
        date.getHours() +
        ":" +
        date.getMinutes()
      );
    },
    backFn() {
      this.$confirm("您还未保存页面内容，确认离开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch(() => {});
    },
    getDraftDetail() {
      this.$axios
        .get(`${RESOURCE_HOST}/api/draft/show?id=${this.belong_id}`)
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.nd_title;
            this.content = detail.nd_content;
            this.resource_url = detail.nd_resource_url;

            this.getTopics(detail.global_id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getScriptDetail() {
      this.$axios
        .get(
          this.$route.query.isPub == 1
            ? `${SWNEWS_HOST}/api/news/getNewsInfo?id=${this.$route.query.nid}`
            : `${RESOURCE_HOST}/api/manuscript/show?id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (this.$route.query.isPub == 1) {
              for (let key in res.data.data) {
                if (key.indexOf("n_") >= 0 && key != "n_id") {
                  res.data.data[key.replace("n_", "nm_")] = res.data.data[key];
                }
              }
            }

            let detail = res.data.data;
            this.title = detail.nm_title;
            this.content = detail.nm_content;
            this.resource_url = detail.nm_resource_url;

            this.getTopics(detail.global_id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getMaterialDetail() {
      this.$axios
        .post(`${RESOURCE_HOST}/api/material/showChild`, {
          id: this.belong_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            if (detail.cm_type == 2) {
              this.resource_url = [detail.cm_url];
              this.material_ids = this.belong_id;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getDhyDetail() {
      this.$axios
        .get(
          `${RESOURCE_HOST}/common/cloudnews/getTmpInfo?big_cloud_id=${this.belong_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.n_title;
            this.content = detail.n_content.substr(0, 400);
            try {
              detail.n_resource_url = eval("(" + detail.n_resource_url + ")");
            } catch (error) {}
            this.resource_url = detail.n_resource_url;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getMediaDetail() {
      this.$axios
        .get(
          `${MEDIA_HOST}/biz/outer/news/queryBy?id=${this.belong_id}&&appId=${this.$route.query.appId}&&orgId=${this.$route.query.orgId}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            let detail = res.data.data;
            this.title = detail.nmTitle;
            this.content = detail.newsContent.substr(0, 400);
            this.resource_url = detail.nmResourceUrls;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    onBeforeUpload(file) {
      const isIMAGE = file.type.indexOf("image/") >= 0;
      //const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式！");
        return false;
      } else {
        this.loading = true;
        return true;
      }
      // if (!isLt1M) {
      //   this.$message.error("上传文件大小不能超过 1MB!");
      // } && isLt1M
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.resource_url.push(data.url);

          this.loading = false;
        },
        (error) => {
          console.log("error:" + error);
        },
        (processPercent) => {
          console.log("processPercent:" + processPercent);
        }
      );
    },
    getMaterialList() {
      this.$axios
        .post(`${RESOURCE_HOST}/api/material/list`, {
          cm_type: 3,
          all: 1,
          page: this.page,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.sourceList = this.sourceList.concat(res.data.data.data);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    loadMore() {
      this.page++;
      this.getMaterialList();
    },
    graphDelete(index) {
      this.$confirm("确定要删除该图片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.resource_url.splice(index, 1);
        })
        .catch(() => {});
    },
    insertTopic() {
      this.topicValue = "";
      this.getTopicList("");
      this.insertTopicVisible = true;
    },
    getTopicList(keyword) {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/search?title=${keyword}&page=1&size=50`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.title = element.title.replace(/#/gi, "");
              if (element.id == 0) {
                element.title += "--点击添加新话题";
                element.id = element.title;
              }
            });
            this.topicOptions = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    topicInputChange(val) {
      if (typeof this.topicValue == "string") {
        this.topicValue = this.topicValue.replace(/--点击添加新话题/gi, "");
      }
    },
    insertTopicFn() {
      if (typeof this.topicValue == "string" && this.topicValue == "") {
        this.$message({
          message: "话题不能为空",
          type: "warning",
        });
      } else if (typeof this.topicValue == "string") {
        if (this.topicValue.length > 30) {
          this.$message({
            message: "话题长度不能超过30个字",
            type: "warning",
          });
          return;
        }
        this.$axios
          .post(`${NEWS_HOST}/api/hottopic/add`, {
            title: "#" + this.topicValue + "#",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (this.checkTopic(res.data.data.id)) {
                this.$message({
                  message: "不能添加重复话题",
                  type: "warning",
                });
              } else {
                this.topicShowList.push({
                  title: this.topicValue,
                  id: res.data.data.id,
                });
                this.topicIds.push(res.data.data.id);

                this.insertTopicVisible = false;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else if (this.checkTopic(this.topicValue)) {
        this.$message({
          message: "不能添加重复话题",
          type: "warning",
        });
      } else {
        this.topicOptions.forEach((item) => {
          if (item.id == this.topicValue) {
            this.topicShowList.push({
              title: item.title.replace(/#/gi, ""),
              id: this.topicValue,
            });
            this.topicIds.push(this.topicValue);

            this.insertTopicVisible = false;
          }
        });
      }
    },
    checkTopic(id) {
      return this.topicIds.indexOf(id) > -1;
    },
    deleteTopic(index) {
      this.$confirm("确定要删除该话题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.topicShowList.splice(index, 1);
          this.topicIds.splice(index, 1);
        })
        .catch(() => {});
    },
    getTopics(global_id) {
      this.$axios
        .get(
          `${NEWS_HOST}/api/hottopic/getTopicListByManuscriptId?global_id=${global_id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item) => {
              this.topicIds.push(item.id);
            });
            this.topicShowList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    toTopicPage(id) {
      window.open(
        (window.location.href.indexOf("topnews.cn") >= 0 ||
        window.location.href.indexOf("topnews.cn") >= 0
          ? "https://m.topnews.cn"
          : "https://m.dingnews.net") +
          "/theme/" +
          id
      );
    },
    aiTitleShowFn() {
      let clearContent = this.getClearContent();
      if (clearContent.length < 50) {
        this.$message({
          message: "正文内容必须大于等于50个字",
          type: "warning",
        });
      } else {
        this.aiTitle = ["", "", ""];
        this.aiTitleLoading = true;
        this.aiTitleShow = true;
        this.$axios
          .post(`${RESOURCE_HOST}/common/aiCreate/title`, {
            text: clearContent,
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.aiTitle = res.data.data.title;
              this.aiTitleLoading = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    aiTitleSelect(item) {
      this.title = item;
      this.aiTitleShow = false;
    },
    getClearContent() {
      return this.content
        .replace(/<[^<>]+>/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/\s/g, "");
    },
  },
};
</script>
<style>
.el-input--suffix .el-input__inner {
  background: #f6f7f9;
  border: 0px;
}
.el-textarea__inner {
  background: #f6f7f9;
  border: 0px;
}
</style>

<style lang="scss" scoped>
.memberContainer {
  background: #edf1f8;
  height: 100vh;
  overflow-y: scroll;

  .backBtn {
    width: 970px;
    margin: 0 auto;
    background-color: #fff;
    line-height: 40px;
    padding-left: 20px;
    color: #409eff;

    span {
      cursor: pointer;
    }

    .previewBtn {
      margin-left: 530px;
      display: inline-block;
    }
  }

  .innerContainerGraph {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    background: #edf1f8;

    //左边的内容
    /deep/.editContainer {
      margin: 20px auto 0 auto;
      background: white;
      position: relative;
      width: 856px;
      padding: 56px 40px 32px 40px;

      .el-textarea {
        margin: 0 0 10px 0;
      }

      .sourceListContainer {
        display: flex;

        .inputLabel {
          width: 70px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: bold;
          line-height: 20px;
          text-align: right;
          margin-right: 30px;
        }
      }

      .uploadElemBox {
        width: 100%;
        height: 100%;

        .el-upload {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
          }
        }

        .el-upload-list {
          display: none;
        }
      }

      .graphList {
        display: flex;
        flex-wrap: wrap;

        li {
          width: 124px;
          margin: 0 14px 14px 0;
          border: 1px solid #fff;

          &:nth-child(5n) {
            margin-right: 0;
          }

          .thumbContainer {
            width: 100%;
            height: 93px;
            object-fit: cover;
            position: relative;

            .thumb {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }

            .deleteFn {
              width: 27px;
              position: absolute;
              right: 0;
              top: 0;
              cursor: pointer;
            }
          }
        }
      }

      .el-input__count,
      .el-input__count-inner {
        background-color: #f6f7f9;
      }

      .contentContain {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 12px;
        margin-top: 32px;

        .titleLabel {
          width: 70px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: bold;
          text-align: right;
        }

        .topicBtn {
          width: 21px;
          cursor: pointer;
        }
      }

      .topicListContainer {
        display: flex;
        flex-wrap: wrap;
        margin: 0 0 10px 0;

        .topicList {
          margin-right: 20px;
          font-size: 14px;
          color: #1687d9;
          cursor: pointer;
        }
      }

      .titleContain {
        height: 70px;
        display: flex;
        border-top: 1px solid #e5e6eb;
        margin-top: 21px;
        padding-top: 32px;
        align-items: center;
      }

      .titleLabelContain {
        margin-right: 30px;

        .titleLabel {
          width: 70px;
          color: #333333;
          font-family: "PingFang SC";
          font-size: 14px;
          font-weight: 400;
          font-weight: bold;
          text-align: right;
        }

        .titleAiOutBtn {
          width: 70px;
          cursor: pointer;
          background-color: #ffffff;
          color: #ea0e0e;
          font-family: "PingFang SC";
          font-size: 12px;
          font-weight: 400;
          margin-top: 4px;
          text-align: right;
        }
      }
    }
  }

  /deep/.previewContainer {
    .el-dialog {
      background: url(../../assets/script/preview.png) no-repeat;
      background-size: 100% 100%;
      height: 670px;
      border-radius: 40px;
      padding-top: 70px;
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      height: 519px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      padding-left: 22px;
      padding-right: 22px;
      overflow-y: scroll;

      .closeBtn {
        position: absolute;
        top: 0;
        left: 332px;
        height: 32px;
        cursor: pointer;
      }

      .el-carousel {
        margin: 10px 0 15px 0;

        .el-carousel__item {
          .itemContainer {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          p {
            position: absolute;
            right: 16px;
            bottom: 11px;
            background: rgba(0, 0, 0, 0.7);
            border-radius: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            line-height: 24px;
            padding: 0 10px;
          }
        }

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .info {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        img {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          margin-right: 20px;
        }

        .userName {
          font-size: 14px;
          line-height: 20px;
        }

        .time {
          line-height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }

      .title {
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 31px;
        margin-bottom: 5px;
      }

      .topicsContainer {
        display: flex;
        flex-wrap: wrap;

        .topicShow {
          line-height: 23px !important;
          background: #e8ecff;
          border-radius: 11px;
          color: #5371f3;
          font-size: 14px !important;
          margin-right: 10px !important;
          margin-top: 10px !important;
          padding: 0 8px !important;
          cursor: pointer;
        }
      }
    }
  }

  /deep/.insertTopicContainer {
    .el-dialog__body {
      padding-bottom: 10px;
      padding-top: 10px;
    }
    .el-select {
      width: 100%;
    }
    .el-input {
      width: 100%;
      margin-bottom: 0;
    }
    .el-input__inner {
      width: 100%;
    }
    .submitBtn {
      width: 80px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      color: #333;
      line-height: 36px;
      display: inline-block;
      margin-left: 12px;
    }

    .submitBtn[type="primary"] {
      width: 80px;
      background-color: #ea0e0e;
      border-color: #ea0e0e;
      color: #fff;
    }
  }
}

.titleAiContain {
  padding: 20px;
  margin-left: -54px;
  margin-top: 18px !important;

  .aiTitleList {
    .aiTitleItem {
      display: flex;
      background: #edf1f8;
      padding: 10px 12px;
      margin-top: 12px;
      color: #666666;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;

      .aiTitleLabel {
      }

      .aiTitleContent {
        flex: 1;
      }
    }

    .aiTitleItem:first-child {
      margin-top: 0;
    }

    .aiTitleItem:hover {
      color: #ea0e0e;
    }
  }
}
</style>
